var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 107,
    r: 105.368,
    fill: "url(#paint0_linear_3049_73399)",
    stroke: "url(#paint1_linear_3049_73399)",
    strokeWidth: 2.73677
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2291 92.3401C82.111 118.533 71.5965 154.908 67.4932 167.268C65.1852 143.957 77.3666 112.193 86.2783 93.4288C82.1751 93.6209 60.3126 95.1579 48.1953 107.646C48.1953 107.646 54.7348 87.601 92.4972 81.5171L92.6254 81.2609C122.181 38.1612 144.364 63.9058 144.364 63.9058C130.901 61.6644 119.168 68.3887 109.167 79.3397C114.039 79.1476 145.583 78.7633 154.687 103.675C154.687 103.675 136.414 90.611 99.2291 92.3401ZM120.579 122.375C113.013 122.375 106.858 128.523 106.858 136.08C106.858 143.637 113.013 149.785 120.579 149.785C128.144 149.785 134.299 143.637 134.299 136.08C134.299 128.459 128.144 122.375 120.579 122.375Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3049_73399",
    x1: 53.3662,
    y1: 46.5295,
    x2: 202.968,
    y2: 244.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#601FEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3049_73399",
    x1: 183.69,
    y1: 142.037,
    x2: 50.2087,
    y2: 46.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#601FEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#864EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsn);
export default __webpack_public_path__ + "static/media/fsn.df86783670707fc4064e478d847d9a34.svg";
export { ForwardRef as ReactComponent };